import styled from 'styled-components';

export const ModalStyled = styled.div`
  .Polaris-Scrollable:focus {
    outline: none;
    outline-offset: none;
  }
  .item-container {
    padding: 12px;
    &.item-variant {
      padding-left: 24px;
    }
  }

  .image-container {
    width: '100%';
    height: '100%';
    margin-right: 8px;
  }
`;
